import React, { useEffect, useState, useCallback } from 'react';
import { BorderedQuillContainer } from '../styles';
import TextBlockWithQuillRenderer from '../TextBlockWithQuillRenderer';
import { constructQuillJSON, constructAutoSaveJSON, convertContractToReact } from '../../../utils/TextBlockHelper';
import { useDefaultStyleContext } from '../../../context/complexDefaultStyleContext';
import { dummyCallback } from '../../../utils/complexDocumentConstants';

export const BorderedWhiteQuillRenderer = props => {
  const { uuid, contents, globalVariables = [], updateContent, canUpdateRandomKey } = props;
  const [textEditable, setTextEditable] = useState(false);
  const [randomKey, setRandomKey] = useState(1);

  const getDefaultStyleSelector = useCallback(store => ({fontFamily: store.fontFamily, fontSize:store.fontSize}), []);
  const [documentStyle] = useDefaultStyleContext(getDefaultStyleSelector);

  /*useEffect(() => {
    if (canUpdateRandomKey) {
      console.log("Setting random key :: ");
      setRandomKey(value => value + 1);
    }
  }, [contents]);*/

  const onTextEditorDoubleClick = useCallback(() => {
    setTextEditable(true);
  }, []);

  const onEmptyTextChange = useCallback(
    (contents, u, r, c, ref, op, newGlobalVariables = [], index) => {
      const newContents = constructAutoSaveJSON(contents, documentStyle?.fontFamily, documentStyle?.fontSize, newGlobalVariables);
      updateContent(newContents, newGlobalVariables);
    },
    [documentStyle],
  );

  const onTextBlur = useCallback(() => {
    setTextEditable(false);
  }, []);

  return (
    <BorderedQuillContainer role="button">
      <div
        id={`dynamic-table-empty-text-variable-${uuid}`}
        style={{ position: 'relative', top: 10 }}
      />
      <div>
        <TextBlockWithQuillRenderer
          defaultContent={constructQuillJSON(contents, documentStyle?.fontFamily, documentStyle?.fontSize, globalVariables)}
          saveBlock={onEmptyTextChange}
          itemUUID={uuid}
          selected={textEditable}
          enableSideBar={dummyCallback}
          enableAI={false}
          toolbarInvisible={false}
          adjustScroll={dummyCallback}
          textEditable={true}
          setTextEditable={dummyCallback}
          toolbarDOM={`dynamic-table-empty-text-${uuid}`}
          variableDOM={`dynamic-table-empty-text-variable-${uuid}`}
          isFontSidebarAbsolute={true}
          noFocus={false}
          isFromCreativeBlock={false}
          exposeRef={false}
          onContainerClick={onTextEditorDoubleClick}
          customBlurHandler={onTextBlur}
        />
      </div>
      <div id={`dynamic-table-empty-text-${uuid}`} />
    </BorderedQuillContainer>
  );
};
